const BanzaTimeEditPresets = {
  BanzaTimeEdit: {
    class: "banza-time-edit",
    attrs: {}
  }
};
export {
  BanzaTimeEditPresets as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFuemFUaW1lRWRpdFByZXNldHMuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb25zdGFudHMvY29tcG9uZW50cy9CYW56YVRpbWVFZGl0UHJlc2V0cy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCB7XG4gIEJhbnphVGltZUVkaXQ6IHtcbiAgICBjbGFzczogXCJiYW56YS10aW1lLWVkaXRcIixcbiAgICBhdHRyczoge30sXG4gIH0sXG59O1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQWUsdUJBQUE7QUFBQSxFQUNiLGVBQWU7QUFBQSxJQUNiLE9BQU87QUFBQSxJQUNQLE9BQU8sQ0FBRTtBQUFBLEVBQ1Y7QUFDSDsifQ==
